document.addEventListener('click', async function(event) {

  const button = event.target.closest('.custom-ajax-add');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  button.classList.add('loading');

  try {

    // ADD PRODUCT
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    });

    // GET UPDATED CART DRAWER HTML
    const response = await fetch('/?section_id=cart-drawer');

    const responseText = await response.text();

    const html = new DOMParser().parseFromString(responseText, 'text/html');

    // CURRENT DRAWER
    const currentDrawer = document.querySelector('cart-drawer');

    // NEW DRAWER
    const newDrawer = html.querySelector('cart-drawer');

    if (!currentDrawer || !newDrawer) return;

    // REPLACE CONTENT
    currentDrawer.innerHTML = newDrawer.innerHTML;

    // IMPORTANT FOR BE YOURS
    const details = currentDrawer.querySelector('details');

    if (details) {
      details.setAttribute('open', 'open');
      details.classList.add('menu-opening');
    }

    // LOCK BODY SCROLL
    document.body.classList.add('overflow-hidden');

  } catch (error) {

    console.error('Cart Error:', error);

  } finally {

    button.classList.remove('loading');

  }

});